<template>
  <b-card shadow-sm :class="['mb-4', borderClass, 'position-relative', 'overflow-hidden']">
    <div v-if="loading" class="loading-overlay">
      <b-spinner variant="primary"></b-spinner>
    </div>
    <div :class="{'loading-blur': loading}">
      <div v-if="title" class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="mb-0">{{ title }}</h5>
        <slot name="header-right"></slot>
      </div>
      <div v-if="description" class="small text-muted mb-3">{{ description }}</div>
      <apexchart :type="type" :height="height" :options="allOptions" :series="series"></apexchart>
      <div v-if="footer" class="mt-2 small text-muted text-center">{{ footer }}</div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'DashboardChart',
  props: {
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    footer: { type: String, default: '' },
    type: { type: String, required: true },
    height: { type: [String, Number], default: 300 },
    options: { type: Object, required: true },
    series: { type: Array, required: true },
    borderClass: { type: String, default: 'border-0' },
    loading: { type: Boolean, default: false }
  },
  computed: {
    allOptions() {
      // Allow overriding specific chart types default behavior if needed
      return Object.assign({}, this.options, {
        chart: Object.assign({}, this.options.chart, {
          type: this.type,
          toolbar: { show: false },
          animations: { enabled: true, easing: 'easeinout', speed: 800 }
        })
      });
    }
  }
};
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  backdrop-filter: blur(2px);
}
.loading-blur {
  filter: blur(1px);
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// DashboardChart.vue?1278d188